var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/two_columns.92f606f1.png","uri@3x": __webpack_public_path__ + "static/media/two_columns.3bbc4ddb.png","uri@2x": __webpack_public_path__ + "static/media/two_columns.261188a3.png",
    width: 32,
    height: 32
});